import { toast } from "react-hot-toast";
import { SHORTCUTS } from "./shortcuts";
import ShortcutHint from "../components/shortcuts/ShortcutHint";

// Superhuman-style: when an action is done via mouse, teach its keyboard shortcut.
export const notifyShortcut = (id) => {
  const shortcut = SHORTCUTS[id];
  if (!shortcut) return;

  // Lowercase the first letter so "Valider le dossier" reads naturally mid-sentence.
  const lowerLabel = shortcut.labelFr.charAt(0).toLowerCase() + shortcut.labelFr.slice(1);

  toast.custom(
    (t) => (
      <button
        type="button"
        onClick={() => toast.dismiss(t.id)}
        className={`flex items-center gap-2 rounded-lg bg-white px-4 py-2.5 text-sm text-gray-500 shadow-sm ring-1 ring-black/5 transition-opacity ${t.visible ? "opacity-100" : "opacity-0"}`}
      >
        Astuce : <ShortcutHint id={id} /> pour {lowerLabel}
      </button>
    ),
    { id: "shortcut-tip", duration: 4000, position: "bottom-center" },
  );
};
